import type { SubScene } from "@/api/solutionApi";

interface Props {
  scene: SubScene;
}

export default function DetailHero({ scene }: Props) {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={scene.heroImage}
          alt={scene.name}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
        <div
          className="absolute inset-0 opacity-30"
          style={{ background: `linear-gradient(135deg, ${scene.accentColor}60 0%, transparent 60%)` }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 w-full">
          {/* Category badge */}
          <div className="flex items-center gap-3 mb-6">
            <div
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm"
            >
              <div className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></div>
              <span className="text-white/80 text-xs font-medium tracking-wider">{scene.parentName}</span>
            </div>
          </div>

          {/* Title */}
          <div className="flex items-center gap-4 mb-5">
            <div
              className="w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0"
              style={{ backgroundColor: `${scene.accentColor}cc` }}
            >
              <i className={`${scene.icon} text-white text-xl`}></i>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              {scene.name}
            </h1>
          </div>

          {/* Desc */}
          <p className="text-white/75 text-sm md:text-base max-w-2xl leading-relaxed mb-8">
            {scene.desc}
          </p>

          {/* Tags */}
          <div className="flex flex-wrap gap-2">
            {scene.tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 text-xs font-medium rounded-full border border-white/25 bg-white/10 text-white/85 backdrop-blur-sm"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}
